import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  FormsModule,
  NgForm,
  ReactiveFormsModule,
} from '@angular/forms';
import { ElectricianService } from 'src/app/services/electrician.service';

@Component({
  selector: 'app-electrician-rating',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './electrician-rating.component.html',
  styleUrl: './electrician-rating.component.scss',
})
export class ElectricianRatingComponent implements OnInit {
  reviews: any[] = [];
  selectedElectricianId: string = '';
  editForm: FormGroup;
  editingReview: any = null;
  showModal = false;
  loading = false;
  page = 0;
  totalPages = 1;
  pageSize = 20;

  constructor(
    private electricianService: ElectricianService,
    private fb: FormBuilder
  ) {
    this.editForm = this.fb.group({
      id: [''],
      rating: [''],
      review: [''],
      status: [false],
    });
  }

  ngOnInit(): void {
    this.fetchAllReviews();
  }
  selectedTab: 'approved' | 'pending' = 'approved';

  get filteredReviews() {
    return this.reviews.filter((review) =>
      this.selectedTab === 'approved'
        ? review.approved === true
        : !review.approved
    );
  }

  fetchAllReviews(): void {
    this.loading = true;
    this.electricianService.getAllReviews().subscribe({
      next: (res) => {
        this.reviews = res.content || [];
        this.page = res.number;
        this.totalPages = res.totalPages;
        this.loading = false;
      },
      error: (err) => {
        console.error('Error fetching reviews:', err);
        this.loading = false;
      },
    });
  }

  goToPage(p: number): void {
    this.page = p;
    this.electricianService.getAllReviewsPaginated(this.page).subscribe({
      next: (res) => {
        this.reviews = res.content || [];
        this.page = res.number;
        this.totalPages = res.totalPages;
      },
      error: (err) => {
        console.error('Error loading page:', err);
      },
    });
  }

  getPageArray(): number[] {
    const maxPagesToShow = 3;
    const pages: number[] = [];
    const total = this.totalPages;

    for (let i = 0; i < Math.min(maxPagesToShow, total); i++) {
      pages.push(i);
    }

    return pages;
  }

  shouldShowEllipsis(): boolean {
    return this.totalPages > 4;
  }

  shouldShowLastPage(): boolean {
    return this.totalPages > 4;
  }

  fetchReviewsByElectrician(): void {
    if (!this.selectedElectricianId) return;
    this.loading = true;
    this.electricianService
      .getAllReviewsForElectrician(this.selectedElectricianId)
      .subscribe({
        next: (data) => {
          this.reviews = data;
          this.loading = false;
        },
        error: (err) => {
          console.error('Error fetching reviews for electrician:', err);
          this.loading = false;
        },
      });
  }

  openEditModal(review: any): void {
    this.editingReview = review;
    this.editForm.patchValue({
      id: review.id,
      rating: review.rating,
      review: review.review,
      status: review.approved,
    });
    this.showModal = true;
  }

  closeModal(): void {
    this.showModal = false;
    this.editingReview = null;
  }

  saveReview(): void {
    const updatedReview = this.editForm.value;
    this.electricianService.editReview(updatedReview).subscribe({
      next: () => {
        alert('Review updated successfully');
        this.fetchAllReviews();
        this.closeModal();
      },
      error: (err) => {
        console.error('Error saving review:', err);
        alert('Failed to update review');
      },
    });
  }
}
